import CurrencyDeterminer from "@/module/Form/Currency/CurrencyDeterminer";
import { CurrencySetting } from "@/module/Form/Currency/CurrencySetting";
import ChoiceCurrencyDeterminer from "@/module/Form/Currency/ChoiceCurrencyDeterminer";
import AlwaysCurrencyDeterminer from "@/module/Form/Currency/AlwaysCurrencyDeterminer";
import CountryCurrencyDeterminer from "@/module/Form/Currency/CountryCurrencyDeterminer";

export default class CurrencyDeterminerFactory {
  static create(
    currencySetting: string,
    currency: string | null,
    currencies: Array<string> | null,
    countryCurrencySetting: { [key: string]: string },
  ): CurrencyDeterminer {
    if (currencySetting === CurrencySetting.BY_COUNTRY) {
      return new CountryCurrencyDeterminer(countryCurrencySetting);
    }

    if (currencySetting === CurrencySetting.ALWAYS) {
      return new AlwaysCurrencyDeterminer(currency as string);
    }

    if (currencySetting === CurrencySetting.CHOICE) {
      return new ChoiceCurrencyDeterminer(currencies as Array<string>);
    }

    throw new Error('Unknown currency setting: "' + currencySetting + '".');
  }
}
